export default "__VITE_ASSET__BvYcAmGQ__"